import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import about from "../accests/common/about.jpeg";

import mem1 from "../accests/g/g1 (12).jpeg";
import mem2 from "../accests/g/g1 (10).jpeg";
import mem3 from "../accests/g/g1 (16).jpeg";
import mem6 from "../accests/g/rw.jpeg";

import mem7 from "../accests/g/g1 (7).jpeg";
import mem8 from "../accests/g/g1 (8).jpeg";
import mem9 from "../accests/g/g1 (9).jpeg";
import mem10 from "../accests/g/g1 (10).jpeg";
import mem11 from "../accests/g/g1 (11).jpeg";
import mem12 from "../accests/g/g1 (12).jpeg";
import mem13 from "../accests/g/g1 (13).jpeg";
import mem14 from "../accests/g/g1 (14).jpeg";
import mem15 from "../accests/g/g1 (15).jpeg";
import mem16 from "../accests/g/g1 (16).jpeg";
import mem17 from "../accests/g/g1 (17).jpeg";
import mem18 from "../accests/g/g1 (18).jpeg";
import mem19 from "../accests/g/g1 (19).jpeg";
import mem20 from "../accests/g/g1 (20).jpeg";
import mem21 from "../accests/g/g1 (21).jpeg";
import mem22 from "../accests/g/g1 (22).jpeg";
import mem23 from "../accests/g/g1 (23).jpeg";
import mem24 from "../accests/g/g1 (24).jpeg";
import mem25 from "../accests/g/g1 (25).jpeg";
import mem26 from "../accests/g/g1 (4).jpeg";

import alb1 from "../accests/alberto/a1.jpeg";
import alb2 from "../accests/alberto/a2.jpeg";
import alb3 from "../accests/alberto/a3.jpeg";
import alb4 from "../accests/alberto/a4.jpeg";
import alb5 from "../accests/alberto/a5.jpeg";
import alb6 from "../accests/alberto/a6.jpeg";
import alb7 from "../accests/alberto/a7.jpeg";
import alb8 from "../accests/alberto/a8.jpeg";
import alb9 from "../accests/alberto/a9.jpeg";
import alb10 from "../accests/alberto/a10.jpeg";
import alb11 from "../accests/alberto/a11.jpeg";
import alb12 from "../accests/alberto/a12.jpeg";
import alb13 from "../accests/alberto/a13.jpeg";
import alb14 from "../accests/alberto/a14.jpeg";
import alb15 from "../accests/alberto/a15.jpeg";
import alb16 from "../accests/alberto/a16.jpeg";
import alb17 from "../accests/alberto/a17.jpeg";
import alb18 from "../accests/alberto/a18.jpeg";
import alb19 from "../accests/alberto/a19.jpeg";
import alb20 from "../accests/alberto/a20.jpeg";
import alb21 from "../accests/alberto/a21.jpeg";
import alb22 from "../accests/alberto/a22.mp4";
import alb23 from "../accests/alberto/a23.mp4";
import alb24 from "../accests/alberto/a24.mp4";

import AlbertoGallery from "../component/AlbertoGallery";

/* ---------- tiny inline icons (no extra dependency needed) ---------- */
const IconChevronLeft = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" {...props}>
        <polyline points="15 18 9 12 15 6" />
    </svg>
);
const IconChevronRight = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" {...props}>
        <polyline points="9 18 15 12 9 6" />
    </svg>
);
const IconClose = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" {...props}>
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

/* bento span pattern — repeats every 9 tiles so the grid never looks flat */
const spanClass = (i) => {
    const pos = i % 9;
    if (pos === 0) return "col-span-2 row-span-2";
    if (pos === 4) return "row-span-2";
    if (pos === 7) return "col-span-2";
    return "";
};

export default function Gallery() {

    const [showAlberto, setShowAlberto] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);

    const images = [
        mem2, mem1, mem3, mem6,
        mem7, mem8, mem9, mem10, mem11, mem12, mem13, mem14,
        mem15, mem16, mem17, mem18, mem19, mem20, mem21, mem22,
        mem23, mem24, mem25, mem26,
    ];

    const albertoImages = [
        alb1, alb2, alb3, alb4, alb5, alb6, alb7, alb8, alb9, alb10,
        alb11, alb12, alb13, alb14, alb15, alb16, alb17, alb18, alb19,
        alb20, alb21, alb22, alb23, alb24,
    ];

    const openLightbox = (index) => setActiveIndex(index);
    const closeLightbox = () => setActiveIndex(null);

    const showPrev = useCallback(() => {
        setActiveIndex((i) => (i === null ? null : (i - 1 + images.length) % images.length));
    }, [images.length]);

    const showNext = useCallback(() => {
        setActiveIndex((i) => (i === null ? null : (i + 1) % images.length));
    }, [images.length]);

    useEffect(() => {
        if (activeIndex === null) return;
        const handleKey = (e) => {
            if (e.key === "Escape") closeLightbox();
            if (e.key === "ArrowLeft") showPrev();
            if (e.key === "ArrowRight") showNext();
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [activeIndex, showPrev, showNext]);

    if (showAlberto) {
        return <AlbertoGallery images={albertoImages} onBack={() => setShowAlberto(false)} />;
    }

    return (


        <div className="min-h-screen bg-[#EFEDE3] text-[#12302E]">

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;1,9..144,500&family=Inter:wght@400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
                .font-display { font-family: 'Fraunces', serif; }
                .font-body { font-family: 'Inter', sans-serif; }
                .font-mono { font-family: 'IBM Plex Mono', monospace; }
            `}</style>

            {/* ---------- HERO ---------- */}
            <section className="relative h-[26rem] flex items-end overflow-hidden">
                <img
                    src={about}
                    alt="Sri Lanka Nature"
                    className="absolute inset-0 w-full h-full object-cover scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D2422] via-[#0D2422]/50 to-[#0D2422]/10" />

                <div className="relative max-w-7xl mx-auto w-full px-6 pb-12">
                    <motion.span
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="font-mono text-[#E7B369] text-xs tracking-[0.3em] uppercase"
                    >
                        A collection, kept
                    </motion.span>

                    <motion.h1
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                        className="font-display italic text-5xl md:text-6xl text-[#F7F4EC] mt-3"
                    >
                        Our Memories
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                        className="font-body text-[#F7F4EC]/70 mt-3 max-w-md"
                    >
                        {images.length} moments, one family, and the road through Sri Lanka.
                    </motion.p>
                </div>
            </section>

            {/* ---------- GRID ---------- */}
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">



                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 auto-rows-[150px] md:auto-rows-[190px] gap-3 md:gap-4 grid-flow-dense">

                    {/* Alberto chapter card, folded into the same grid */}
                    <motion.button
                        type="button"
                        onClick={() => setShowAlberto(true)}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        whileHover={{ scale: 0.98 }}
                        className="relative col-span-2 row-span-2 rounded-2xl overflow-hidden group text-left"
                    >
                        <img
                            src={alb19}
                            alt="Alberto Family Tour"
                            className="w-full h-full object-cover transition duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#0D2422]/90 via-[#0D2422]/30 to-transparent" />

                        {/* washi-tape accent */}
                        <span className="absolute -top-2 left-8 w-16 h-6 bg-[#E7B369]/80 rotate-[-6deg] shadow-sm" />

                        <div className="absolute inset-0 flex flex-col items-start justify-end p-6">
                            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#E7B369] mb-2">
                                Featured chapter
                            </span>
                            <h2 className="font-display italic text-2xl md:text-3xl text-white leading-tight">
                                Alberto Family Tour
                                <br />in Sri Lanka
                            </h2>
                            <span className="mt-3 inline-flex items-center gap-1 font-body text-sm text-white/80">
                                View the album <IconChevronRight className="w-4 h-4" />
                            </span>
                        </div>
                    </motion.button>


                    {images.map((img, i) => (
                        <motion.button
                            key={i}
                            type="button"
                            onClick={() => openLightbox(i)}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.4, delay: (i % 9) * 0.04 }}
                            whileHover={{ scale: 0.98 }}
                            className={`group relative rounded-2xl overflow-hidden bg-[#12302E]/5 ${spanClass(i)}`}
                        >
                            <img
                                src={img}
                                alt=""
                                className="w-full h-full object-cover transition duration-500 group-hover:scale-110 group-hover:brightness-90"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-300" />
                            <span className="absolute bottom-3 left-3 font-mono text-[10px] tracking-widest text-white opacity-0 group-hover:opacity-90 transition duration-300">
                                {String(i + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
                            </span>
                        </motion.button>
                    ))}



                </div>
            </div>

            {/* ---------- LIGHTBOX ---------- */}
            <AnimatePresence>
                {activeIndex !== null && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-50 bg-[#0D2422]/95 backdrop-blur-sm flex items-center justify-center p-4 md:p-10"
                        onClick={closeLightbox}
                    >
                        <button
                            onClick={closeLightbox}
                            aria-label="Close"
                            className="absolute top-5 right-5 md:top-8 md:right-8 text-white/80 hover:text-white transition p-2 rounded-full hover:bg-white/10"
                        >
                            <IconClose className="w-6 h-6" />
                        </button>

                        <button
                            onClick={(e) => { e.stopPropagation(); showPrev(); }}
                            aria-label="Previous image"
                            className="absolute left-3 md:left-8 text-white/80 hover:text-white transition p-2 md:p-3 rounded-full hover:bg-white/10"
                        >
                            <IconChevronLeft className="w-7 h-7 md:w-8 md:h-8" />
                        </button>

                        <motion.div
                            key={activeIndex}
                            initial={{ opacity: 0, scale: 0.96 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.98 }}
                            transition={{ duration: 0.25 }}
                            className="relative max-w-4xl w-full"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img
                                src={images[activeIndex]}
                                alt=""
                                className="w-full max-h-[78vh] object-contain rounded-xl shadow-2xl"
                            />
                            <p className="text-center font-mono text-xs tracking-[0.3em] text-white/50 mt-4">
                                {String(activeIndex + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
                            </p>
                        </motion.div>

                        <button
                            onClick={(e) => { e.stopPropagation(); showNext(); }}
                            aria-label="Next image"
                            className="absolute right-3 md:right-8 text-white/80 hover:text-white transition p-2 md:p-3 rounded-full hover:bg-white/10"
                        >
                            <IconChevronRight className="w-7 h-7 md:w-8 md:h-8" />
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>

        </div>
    );
}
